/* eslint-disable react-refresh/only-export-components */
import { PATHS } from "@/constants/path"
import { Navigate } from "react-router-dom"
import { createLogger } from "@/utils/logger"

const logger = createLogger("Redirect")

export function RedirectHomePage() {
    return (
        <Navigate
            to={PATHS.INDEX}
            replace
        />
    )
}

export function RedirectGamePage(props: { gameName?: string }) {
    return (
        <Navigate
            to={`${PATHS.GAME_PAGE_BASE}/${props.gameName}`}
            replace
            state={{
                back: PATHS.INDEX,
            }}
        />
    )
}

export function createRedirectComponent<P>(Component: React.ComponentType<P>, props?: P) {
    return function RedirectComponent() {
        // @ts-ignore
        return <Component {...props} />
    }
}
